import type { ForeignPaymentCreateInput, PaymentRequestCreateInput } from '@veem/crm-schema'
import { FOREIGN_PAYMENTS } from '../../prototype/data/foreign-payments.ts'
import { proto } from '../../prototype/state/store.ts'
import {
  financeMutation,
  financeVersion,
  refreshFinance,
  uploadFinanceFile,
} from '../finance/actions.ts'

const version = (id: string) =>
  financeVersion(proto.state.paymentRequests.find((row) => row.id === id))
export const paymentRequestActions = {
  createPaymentRequest: async (input: PaymentRequestCreateInput & { fileName: string | null }) => {
    const { fileName: _fileName, ...body } = input
    return (await financeMutation<{ id: string }>('/payment-requests', body, 'POST')).id
  },
  decidePaymentRequest: async (id: string, status: 'approved' | 'rejected', reason?: string) => {
    await financeMutation(`/payment-requests/${id}/decide`, {
      version: version(id),
      status,
      reason,
    })
  },
  transitionPaymentRequest: async (
    id: string,
    status: string,
    reason: string,
  ): Promise<string | null> => {
    await financeMutation(`/payment-requests/${id}/transition`, {
      version: version(id),
      status,
      reason,
    })
    return null
  },
  markPaymentRequestPaid: async (
    id: string,
    input: { paidAt: string; reference: string | null },
  ) => {
    await financeMutation(`/payment-requests/${id}/pay`, { ...input, version: version(id) })
  },
  undoPaymentRequestPaid: async (id: string, reason: string) => {
    await financeMutation(`/payment-requests/${id}/undo`, { version: version(id), reason })
  },
}
export const attachPaymentRequestFile = async (id: string, file: File) =>
  uploadFinanceFile(`/payment-requests/${id}/files`, version(id), file)
export interface ForeignPaymentProgress {
  id?: string
  version?: number
  uploaded: Set<File>
}
export const createForeignPayment = async (
  input: ForeignPaymentCreateInput,
  files: File[],
  progress: ForeignPaymentProgress,
) => {
  if (files.some((file) => !file.size)) throw new Error('Оберіть непорожні файли')
  if (!progress.id) {
    const row = await financeMutation<{ id: string; version: number }>(
      '/payment-requests/foreign',
      input,
      'POST',
    )
    progress.id = row.id
    progress.version = row.version
  }
  if (progress.id) {
    await refreshFinance()
    const current = FOREIGN_PAYMENTS.find((row) => row.id === progress.id)
    if (current) progress.version = financeVersion(current)
  }
  for (const file of files) {
    if (progress.uploaded.has(file)) continue
    const added = await uploadFinanceFile(
      `/payment-requests/${progress.id}/files`,
      progress.version ?? 1,
      file,
      'foreign_payment',
    )
    progress.version = added.version
    progress.uploaded.add(file)
  }
  return progress.id
}
